
<template>
  <main>
  <div class="card-body">
    <form id="frmLogin" onSubmit="return false;" class="form">
      <div class="form-group">
        <div class="input-wrapper">
            <select name="sys_gbn" v-model="sys_gbn" class="select">
              <option v-for="item in sys_gbn_list" :value="item" :key="item.id" >
                {{ item.name }}
              </option>
            </select>
            </div>
      </div>    
      <div class="form-group">
        <div class="input-wrapper">
          <input type="text" name="uid" ref="uid" class="input" placeholder="ID" v-model.trim="uid" autocomplete="off"/>
        </div>
      </div>
      <div class="form-group">
        <div class="input-wrapper">
          <input type="password" name="pwd" ref="pwd" id="pwd" class="input" placeholder="Password"
        v-model.trim="pwd"
        autocomplete="off"
        maxlength="20"
        v-on:keyup.enter=onLogin()>
        </div>
      </div>
      <button name="login" id="login" class="btn-Login" type="button" @click="onLogin">Login</button>
    </form>
    <form id="frmLogin1" name="frmLogin1" method="post">
        <input type="hidden" name="guid" id="guid" />
    </form>
    <div class="text-center mt-3">
        <a href="#" @click="onComplaintModal">[직원의 고충 실리콘투가 해결해드립니다.]</a>
      </div>
  </div>

<!-- Complaint  Modal Start -->
  <div
    ref="modal"
    class="modal fade"
    :class="{show, 'd-block': complaint_active}"
    tabindex="-1"
    role="dialog"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header alert-primary">
          <h6 class="modal-title">직원의 고충 실리콘투가 해결해드립니다.</h6>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            @click="onComplaintModal"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="alert alert-warning" style="">
              <p>고충사항, 건의사항 등 직원의 고민을 남겨주세요.</p>
          </div>
          <form id="frmComplaint" onSubmit="return false;">
            <div class="form-group">
              <label for="now_today" class="col-form-label">작성일 : {{ now_today }}</label>
            </div>
            <div class="form-group">
              <label for="subj" class="col-form-label">제목:</label>
              <input type="text" class="form-control" id="subj" name="subj" ref="subj" v-model.trim="subj"/>
            </div>
            <div class="form-group h-100">
              <label for="bdoc_body" class="col-form-label">내용:</label>
              <textarea class="form-control" id="bdoc_body" name="bdoc_body" role="10" ref="bdoc_body" v-model.trim="bdoc_body"></textarea>
            </div>
            <div class="form-group">
              <label for="fileUpload" class="col-form-label">첨부파일</label>
              <div
                class="upload-area"
                @dragover.prevent
                @drop="handleDrop"
                @click="triggerFileUpload"
                @dragenter.prevent="preventDefaults"
                @dragleave.prevent="preventDefaults"
              >
                <input
                  type="file"
                  id="fileUpload"
                  ref="fileUpload"
                  class="form-control-file"
                  @change="handleFileUpload"
                  multiple
                  style="display: none;" 
                />
                <p class="text-muted">Drag and drop files here or click to select files</p>
              </div>

              <!-- 업로드된 파일 목록 -->
              <div v-if="uploadedFiles.length" class="mt-3">
                <h6>업로드된 파일 목록:</h6>
                <ul class="list-group">
                  <li v-for="(file, index) in uploadedFiles" :key="index" class="list-group-item d-flex justify-content-between align-items-center">
                    <span>
                      {{ file.name }} - {{ (file.size / 1024).toFixed(2) }} KB
                    </span>
                    <button @click="removeFile(index)" class="btn btn-link text-danger p-0" title="삭제">
                      <i class="fa fa-trash"></i>
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-primary" @click="onComplaintSave">Save</button>
        </div>
      </div>
    </div>
  </div>
  <div v-if="complaint_active" class="modal-backdrop fade show"></div>
</main>
<!-- Complaint  Modal End -->
</template>
<script>
import VueCookies from 'vue-cookies';
import { lfnLogin, lfnComplaintSave } from '@/Service/Login/Login';
import '@fortawesome/fontawesome-free/css/all.min.css';

var sSysSaveYn  = VueCookies.get("sysSaveYn");
var sUidSaveYn  = VueCookies.get("uidSaveYn");
var sSysGbnC = VueCookies.get("sysGbn");

var sUid  = VueCookies.get("userId");
let now_hostname = window.location.hostname;

let params = (new URL(window.location)).searchParams;
let sSysGbn = params.get('sys_gbn');
let sRtnUrl = params.get('rtn_url');

let today = new Date();

let year = today.getFullYear();
let month = ('0' + (today.getMonth() + 1)).slice(-2);
let day = ('0' + today.getDate()).slice(-2);

let dateString = year + '-' + month  + '-' + day;

export default {
  name: "login",
  data() {
    return {
      uid: "",
      pwd: "",
      sys_gbn: "",
      sysSaveYn: "",
      uidSaveYn: "",
      sRtnUrl: sRtnUrl,
      sys_gbn_list: '',
      now_year: '',
      tmpUid : "",
      tmpPwd : "",
      complaint_active: false,
      show: false,
      subj : "",
      bdoc_body : "",
      uploadedFiles: [],
      now_today : dateString
    };
  },
  created: function() {
     this.onCodeList();
     this.now_year = new Date().getFullYear();
  },
  mounted() {
    this.onSetInitValues();
  },
  methods: {
      async onLogin() {

          if(this.uid == "" )
          {
            this.$nextTick(() => this.$refs.uid.focus())
            return false;
          }

          if(this.pwd == "" )
          {
            this.$nextTick(() => this.$refs.pwd.focus())
            return false;
          }

          if (this.uid !="" && this.pwd != "")
          {
            lfnLogin(this.uid,this.pwd,this.sys_gbn,this.sysSaveYn,this.uidSaveYn,sRtnUrl);
          }
      },
      onSetInitValues() {
          if (sSysGbn == null)
          {
             sSysGbn = "CSMS"

            if(sSysGbnC != null)
            {
              sSysGbn = sSysGbnC;
            }
            this.sys_gbn = this.sys_gbn_list.find(i => i.id === sSysGbn);
          }
          else{
            this.sys_gbn = this.sys_gbn_list.find(i => i.id === sSysGbn);
          }

          if ((sSysSaveYn || "") == "Y")
          {
            this.sysSaveYn = true;
          }

          if ((sUidSaveYn || "") == "Y")
          {
            this.uidSaveYn = true;
          }

          if((sUid || "") == "")
          {
            this.uid = sUid;
          }
          this.$refs.uid.focus();
      },
      onCodeList() {
        this.sys_gbn_list = [
                {id: 'IDMS', name: '[IDMS] 통합 데이터 관리 시스템'},
                {id: 'CSMS', name: '[CMS] 화장품 영업관리 시스템'},
                {id: 'INSA', name: '[INSA] 인사 시스템'}
              ]
      },
      onComplaintModal() {
            const body = document.querySelector("body");
            this.complaint_active = !this.complaint_active;
            this.complaint_active ? body.classList.add("modal-open") : body.classList.remove("modal-open");

            if(!this.complaint_active){
              this.subj = "";
              this.bdoc_body = "";
              this.uploadedFiles =[];
            }

            setTimeout(() => (this.show = !this.show), 10);
      },
      handleFileUpload(event) {
        const files = Array.from(event.target.files);
        this.uploadedFiles.push(...files);
      },
      handleDrop(event) {
        event.preventDefault(); // 기본 동작 방지
        event.stopPropagation(); // 이벤트 전파 방지
        const files = Array.from(event.dataTransfer.files);
        this.uploadedFiles.push(...files);
      },
      triggerFileUpload() {
        this.$refs.fileUpload.click(); // 클릭 시 파일 선택창을 열도록 설정
      },
      preventDefaults(event) {
        event.preventDefault(); // 기본 동작 방지
        event.stopPropagation(); // 이벤트 전파 방지
      },
      removeFile(index) {
        this.uploadedFiles.splice(index, 1); // 파일 배열에서 해당 인덱스의 파일 삭제
      },
      async onComplaintSave(){

        //소원수리함 저장
        if(this.subj == "" )
        {
          this.$nextTick(() => this.$refs.subj.focus())
          return false;
        }

        if(this.bdoc_body == "" )
        {
          this.$nextTick(() => this.$refs.bdoc_body.focus())
          return false;
        }

        const formData = new FormData();
        formData.append("wout_user", now_hostname.split(".")[0]);
        formData.append("wout_user_nm",  now_hostname.split(".")[0]);
        formData.append("subj", this.subj);
        formData.append("bdoc_body", this.bdoc_body);
        this.uploadedFiles.forEach((file, index) => {
          formData.append(`${index}`, file);
        });

        let ComplaintData = await lfnComplaintSave(formData);

        if(ComplaintData.onResult == 0){
          if(ComplaintData.onRowCount > 0){
            // 저장완료시 팝업 닫기 호출
            alert("정상적으로 저장 되었습니다.");
            this.onComplaintModal();
          }
        }

      },
      setFocus:function(o){
        if(o == "uid")
          this.uid = this.tmpUid;
        else
          this.pwd = this.tmpPwd;
      },
      outFocus:function(o){
        if(o == "uid")
           this.tmpUid = this.uid;
        else
          this.tmpPwd = this.pwd;
      }
  }
};
</script>

<style scoped>
.upload-area {
  border: 2px dashed #ccc;
  border-radius: 6px;
  padding: 20px;
  text-align: center;
  cursor: pointer;
  background-color: #f9f9f9;
  transition: border-color 0.3s ease;
}
.upload-area:hover {
  border-color: #007bff;
}
.upload-area p {
  margin: 0;
}

.form-control-file {
  opacity: 0;
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  cursor: pointer;
}

.list-group-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>